const accordionsInit = function () {
	const accordions = document.querySelectorAll('.accordion');

	if (accordions) {
		accordions.forEach((accordion) => {
			const toggle = accordion.querySelector('.accordion__button');

			// If js is running, close all accordions.
			accordion.classList.remove('accordion--open');
			toggle.setAttribute('aria-expanded', 'false');

			toggle.addEventListener('click', function () {
				if (accordion.classList.contains('accordion--open')) {
					accordion.classList.remove('accordion--open');
					toggle.setAttribute('aria-expanded', 'false');
				} else {
					accordion.classList.add('accordion--open');
					toggle.setAttribute('aria-expanded', 'true');
				}
			});
		});

		// Have first accordion on any page open by default (except if homepage).
		if(accordions[0] && ! document.querySelector('body.home') ) {
			accordions[0].querySelector('.accordion__button').click();
		}
	}

	const flagshipAccordions = document.querySelectorAll('.flagship-accordion');

	if (flagshipAccordions) {
		flagshipAccordions.forEach((accordion) => {
			const toggle = accordion.querySelector('.flagship-accordion__text');
			const close  = accordion.querySelector('.flagship-accordion__close span');

			// If js is running, close all accordions.
			accordion.classList.add('active');
			accordion.classList.remove('flagship-accordion--open');
			toggle.setAttribute('aria-expanded', 'false');
			close.setAttribute('aria-expanded', 'false');

			toggle.addEventListener('click', function () {
				if (accordion.classList.contains('flagship-accordion--open')) {
					accordion.classList.remove('flagship-accordion--open');
					toggle.setAttribute('aria-expanded', 'false');
					close.setAttribute('aria-expanded', 'false');
				} else {
					accordion.classList.add('flagship-accordion--open');
					toggle.setAttribute('aria-expanded', 'true');
					close.setAttribute('aria-expanded', 'true');
				}
			});

			close.addEventListener('click', function () {
				accordion.classList.remove('flagship-accordion--open');
				toggle.setAttribute('aria-expanded', 'false');
				close.setAttribute('aria-expanded', 'false');
				accordion.scrollIntoView(true);
			});

		});
	}

};
export default accordionsInit;
